export type TUploadedFile = {
  itemId: string;
  uploadId: string;
};

export enum FileUploaderErrorCodes {
  FILE_TOO_LAGE = 'err_file_too_large',
  NETWORK = 'err_network',
  BAD_REQUEST = 'err_bad_request',
  RETRY_BUTTON = 'err_network_retry_button',
  FILE_LIMIT_REACHED = 'err_file_limit_reached',
}

export type FileUploaderErrorCode =
  | FileUploaderErrorCodes.FILE_TOO_LAGE
  | FileUploaderErrorCodes.NETWORK
  | FileUploaderErrorCodes.BAD_REQUEST
  | FileUploaderErrorCodes.RETRY_BUTTON
  | FileUploaderErrorCodes.FILE_LIMIT_REACHED;

export type TFile = {
  id: string;
  file: File;
  errorCode?: FileUploaderErrorCode;
  errorMessage?: string;
};

export type TFileUploadError = {
  errorCode: FileUploaderErrorCode;
  errorMessage: string;
};

export const DropzoneErrorCodes = {
  FILE_TO_LARGE: 'file-too-large',
  FILE_INVALID_TYPE: 'file-invalid-type',
  TOO_MANY_FILES: 'too-many-files',
};
